
import EmployeeDepartment from './main';

export default {
  components: {
    EmployeeDepartment: EmployeeDepartment
  },
  inheritAttrs: false,
  props: {
    // 内容框类型
    contentBlock: {
      type: Boolean,
      default: true
    },
    // 显示位置
    placement: {
      type: String,
      default: 'bottom-start'
    }
  },
  data: function data() {
    return {
      popoverVisible: false,
      data: {},
      // 内容展示
      popoverContentShow: false
    };
  },

  computed: {
    popoverWidth: function popoverWidth() {
      return this.isRadio ? '300' : '600';
    },
    activeTabName: function activeTabName() {
      return this.$refs.employeeDepartment ? this.$refs.employeeDepartment.activeTabName : '';
    },
    isRadio: function isRadio() {
      return this.$attrs.radio || false;
    }
  },
  watch: {
    popoverVisible: function popoverVisible(val) {
      if (val) {
        // this.updateCheckInfoByWatch()
      }

      this.$emit('show', val);
    }
  },
  methods: {
    // 提交按钮
    popoverSubmit: function popoverSubmit() {
      this.popoverVisible = false;
      this.$emit('popoverSubmit', this.$refs.employeeDepartment.checkedUserDepList.filter(function (item) {
        return item.type == 'user';
      }), this.$refs.employeeDepartment.checkedUserDepList.filter(function (item) {
        return item.type == 'dep';
      }));
    },


    // 内容可见
    showContentClick: function showContentClick() {
      if (!this.popoverContentShow) {
        this.popoverContentShow = true;
      }
    }
  }
};